import React, {useEffect, useState} from 'react';
import './in-execution-icon.css';
import {HourglassBottom, HourglassFull, HourglassTop} from "@mui/icons-material";

export const InExecutionIconComponent = () => {
    const hourglassIcons = [HourglassBottom, HourglassFull, HourglassTop];
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % hourglassIcons.length);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="badge-container">
            {React.createElement(hourglassIcons[index], { className: "hourglass-icon rotate-horizontal-vertical" })}
            <strong className="badge-text">Em execução</strong>
        </div>
    );
};
